import Stage, { getServerSideProps } from './Stage';
export default Stage;
export { getServerSideProps };
